import * as React from 'react';

import type { InjectedIntlProps } from 'react-intl';
import { FormattedMessage, injectIntl } from 'react-intl';

import { isRefactoringTwoStepLoginResponseEnabled } from 'feature-flags';
import * as qs from 'query-string';
import { TextField } from '@atlassian/help-center-common-component/fields/text-field';
import { ThemedButton } from '@atlassian/help-center-common-component/themed-button';
import { ThemedLink } from '@atlassian/help-center-common-component/themed-link';
import { FireScreenEventOnMount } from '@atlassian/help-center-common-util/analytics/fire-screen-event';
import { origin } from '@atlassian/help-center-common-util/location';
import messages from './messages';
import { ButtonContainer, Container, InfoSectionContainer, InfoSectionContent, InfoSectionTitle } from './styled';

interface LoginSingleSignOnProps {
    email: string;
    continueParam: string; //remove when removingfix-user-self-join-flow-from-portal-when-user-already-in-the-userbase_sztub
    redirectUrlLegacy: string; //remove when removingfix-user-self-join-flow-from-portal-when-user-already-in-the-userbase_sztub
    redirectUrl?: string; //remove the optional after cleaning up fix-user-self-join-flow-from-portal-when-user-already-in-the-userbase_sztub
}

export class LoginSingleSignOn extends React.Component<LoginSingleSignOnProps & InjectedIntlProps> {
    getSSOUrlLegacy = () => {
        const { email, continueParam, redirectUrlLegacy } = this.props;

        const searchString = qs.stringify({
            email,
            continue: continueParam,
            application: 'ondemand',
            tenant: origin(),
        });

        return `${redirectUrlLegacy}?${searchString}`;
    };

    getSSOUrl = () => {
        const { redirectUrl } = this.props;

        return redirectUrl || this.getSSOUrlLegacy();
    };

    getSSOFormContent = () => {
        const { intl, email } = this.props;

        return (
            <TextField
                id="user-email"
                shouldFitContainer
                label={intl.formatMessage(messages.emailLabel)}
                disabled
                defaultValue={email}
            />
        );
    };

    getAtlassianAccountInfoSection = () => {
        const { intl } = this.props;

        const URI = 'https://support.atlassian.com/atlassian-account/docs/what-is-an-atlassian-account/';

        const supportLink = (
            <ThemedLink actionSubjectId="learnMoreAtlassianAccount" href={URI} target="_blank">
                {intl.formatMessage(messages.atlassianAccountInfoLink)}
            </ThemedLink>
        );

        return (
            <InfoSectionContainer>
                <InfoSectionTitle>
                    <FormattedMessage {...messages.atlassianAccountInfoTitle} />
                </InfoSectionTitle>
                <InfoSectionContent>
                    <FormattedMessage {...messages.atlassianAccountInfoContent} values={{ supportLink }} />
                </InfoSectionContent>
            </InfoSectionContainer>
        );
    };

    render() {
        return (
            <Container>
                <FireScreenEventOnMount />
                {this.getSSOFormContent()}
                <ButtonContainer>
                    <ThemedButton
                        id="login-button"
                        data-test-id="login-sso-button"
                        appearance="primary"
                        shouldFitContainer
                        actionSubjectId="submitLoginSSO"
                        href={isRefactoringTwoStepLoginResponseEnabled() ? this.getSSOUrl() : this.getSSOUrlLegacy()}
                        // Disabling existing violations, should be fixed when revisited.
                        // eslint-disable-next-line jsx-a11y/no-autofocus
                        autoFocus
                    >
                        <FormattedMessage {...messages.continueWithAtlassianAccountButton} />
                    </ThemedButton>
                </ButtonContainer>
                {this.getAtlassianAccountInfoSection()}
            </Container>
        );
    }
}

export default injectIntl(LoginSingleSignOn);
